import digiDesign from "../assets/images/digiplus.png";
import ficasDesign from "../assets/images/ficas.png";
import parsDesign from "../assets/images/parsshir.png";

import BigData from "../assets/images/BigData.jpeg";
import ObjectDetection from "../assets/images/ObjectDetection.webp";
import ImageCaptioning from "../assets/images/captiongenerator.gif";
import ElectricityConsumptionForecast from "../assets/images/ElectricityConsumptionForecast.jpg";

import blogImage2 from "../assets/images/blog-image-2.jpg";
import blogImage6 from "../assets/images/blog-image-6.jpg";
import blogImage7 from "../assets/images/AboutImg.jpg";

const en = {
  locale: "en",

  name: "Mehdi Talebi",
  navRole: "AI Engineer",
  openNavigation: "Open navigation",

  home: "HOME",
  about: "ABOUT",
  resume: "RESUME",
  portfolio: "PROJECTS",
  blog: "WRITING",
  contact: "CONTACT",

  hi: "Hi, I'm ",
  hi2: "",

  homeKicker: "Applied AI · Machine Learning · Software Engineering",
  homeHeadline: "I build intelligent systems that connect research with real products.",
  desc:
    "AI engineer working across applied AI, machine learning, computer vision, and software engineering. My experience spans multi-object tracking and autonomous-driving research as well as recommendation, ranking, visual similarity search, intelligent product discovery, and AI-enabled business systems.",

  homeProofTitle: "What I work on",
  homeProofLead:
    "A compact view of the three areas that best describe my current work and research.",

  homeSignals: [
    "Research — SNN + BLS, multi-object tracking, autonomous-driving perception, KITTI.",
    "Applied AI — recommendation, ranking, personalization, visual search, and intelligent product discovery.",
    "Engineering — Python, React, APIs, data workflows, commerce systems, and production web software.",
  ],

  viewProjects: "View Projects",
  downloadcv: "Download Resume",

  aboutme: "ABOUT ME",
  aboutEyebrow: "Profile",
  aboutDescription:
    "I work at the intersection of applied AI, computer vision, machine learning, and software engineering. My background combines research with hands-on product development: from multi-object tracking and autonomous-driving perception to recommendation systems, visual similarity search, intelligent product discovery, AI assistants, and software used in real business workflows. I care about building systems that are technically sound, maintainable, and useful beyond a demo.",
  aboutJourney:
    "My academic path began with a B.Sc. in Textile Engineering at Amirkabir University of Technology. I later changed fields through the Computer Engineering entrance path and completed an M.Sc. in Data Science at Shahid Beheshti University, focusing my research on AI and computer vision.",
  aboutImageAlt: "Artificial intelligence and software engineering workspace",
  aboutFocusTags: [
    "Applied AI",
    "Machine Learning",
    "Computer Vision",
    "Recommendation Systems",
    "Intelligent Search",
    "Software Engineering",
  ],

  coreAreasTitle: "CORE AREAS",
  coreAreasEyebrow: "Focus",
  coreAreas: [
    {
      id: "ai",
      icon: "ai",
      title: "Applied AI & Machine Learning",
      desc:
        "Designing AI features around real product and business problems, including recommendation, ranking, personalization, intelligent search, and data-driven decision support.",
    },
    {
      id: "cv",
      icon: "cv",
      title: "Computer Vision & Intelligent Perception",
      desc:
        "Research and engineering in object detection, multi-object tracking, visual similarity search, temporal modeling, and autonomous-driving perception.",
    },
    {
      id: "software",
      icon: "software",
      title: "Software & Product Engineering",
      desc:
        "Building practical software around AI systems with Python, JavaScript, React, APIs, databases, WordPress/WooCommerce, and operational web workflows.",
    },
  ],

  fullname: "Full Name",
  age: "Age",
  languages: "Languages",
  address: "Location",
  phone: "Phone",
  availabilityLabel: "Availability",
  persian: "Persian",
  english: "English",
  street: "Tehran, Iran",
  available: "Open to relevant AI and engineering opportunities",
  tel: "(+98) 935 973 2264",

  resumePageTitle: "RESUME",
  resumeEyebrow: "Experience & Education",
  workingexperience: "Professional Experience",

  workingSteps: [
    {
      id: 1,
      date: "Dec 2023 - Present",
      title: "AI & Web Technology Manager",
      subtitle: "Petro Nour Mehr International Company",
      content:
        "Designing and developing AI-enabled product and business systems, including a knowledge-based customer assistant and intelligent product search. The role connects applied AI, product data, web engineering, and real commercial workflows.",
    },
    {
      id: 2,
      date: "Nov 2022 - Nov 2025",
      title: "Research Assistant — Computer Vision & Autonomous Systems",
      subtitle: "Shahid Beheshti University",
      content:
        "Conducted research in computer vision, deep learning, autonomous driving, and multi-object tracking. My graduate work designed and evaluated a hybrid architecture combining Spiking Neural Networks and Broad Learning Systems on the KITTI dataset.",
    },
    {
      id: 3,
      date: "Mar 2021 - Jan 2022",
      title: "Frontend Web Developer",
      subtitle: "Digikala",
      content:
        "Contributed to frontend development for a large-scale e-commerce platform, working with React-based interfaces and production web experiences.",
    },
  ],

  educationalqualifications: "Education",
  educationalSteps: [
    {
      id: 1,
      date: "Oct 2022 - Oct 2025",
      title: "M.Sc. in Data Science — Computer Engineering",
      subtitle: "Shahid Beheshti University — School of Computer Science & Engineering",
      content:
        "Graduate study focused on machine learning, computer vision, intelligent systems, and autonomous-driving perception. The thesis was defended in October 2025.",
    },
    {
      id: 2,
      date: "Oct 2015 - Feb 2021",
      title: "B.Sc. in Textile Engineering",
      subtitle: "Amirkabir University of Technology — Tehran Polytechnic",
      content:
        "Completed an engineering undergraduate degree before transitioning academically and professionally into computer engineering, data science, and artificial intelligence.",
    },
  ],

  researchSpotlight: "Research Spotlight",
  researchTitle: "Hybrid Spiking Neural Network + Broad Learning System for Multi-Object Tracking",
  researchDescription:
    "My M.Sc. thesis investigated a hybrid SNN–BLS architecture for multi-object tracking in autonomous-driving scenarios. The system combined MobileNetV3/FPN-based feature extraction, Broad Learning feature enhancement, LIF-based spiking layers with temporal coding, and Kalman/Hungarian track association, evaluated on KITTI.",
  researchTags: [
    "Spiking Neural Networks",
    "Broad Learning System",
    "Multi-Object Tracking",
    "KITTI",
    "Autonomous Driving",
    "Computer Vision",
  ],
  researchStats: [
    { value: "77.93", label: "HOTA on the internal KITTI evaluation split" },
    { value: "<27 ms", label: "End-to-end processing time per frame on NVIDIA A100" },
    { value: "~9.2%", label: "Spike activity reported in the proposed architecture" },
    { value: "KITTI", label: "Autonomous-driving dataset used for evaluation" },
  ],

  myskills: "Technical Capabilities",
  skillGroups: [
    {
      title: "Applied AI & Machine Learning",
      items: [
        "Machine Learning",
        "Deep Learning",
        "Recommendation Systems",
        "Ranking Systems",
        "Personalization",
        "Intelligent Search",
        "Visual Similarity Search",
        "Data Analysis",
      ],
    },
    {
      title: "Computer Vision & Research",
      items: [
        "Computer Vision",
        "Multi-Object Tracking",
        "Object Detection",
        "Re-Identification",
        "Spiking Neural Networks",
        "Broad Learning Systems",
        "Temporal Modeling",
        "OpenCV",
      ],
    },
    {
      title: "AI / Data Engineering",
      items: [
        "Python",
        "PyTorch",
        "TensorFlow",
        "Keras",
        "Scikit-learn",
        "NumPy",
        "pandas",
        "SQL",
      ],
    },
    {
      title: "Software & Product Engineering",
      items: [
        "JavaScript",
        "React",
        "Node.js",
        "REST APIs",
        "WordPress",
        "WooCommerce",
        "PHP",
        "MySQL",
      ],
    },
  ],

  portfolioEyebrow: "Selected Work",
  portfolioLead:
    "A focused selection of research, applied-AI systems, and software projects. The emphasis is on the technical problem, what was implemented, and how the work connects to a real use case.",
  featuredWork: "Featured Work",
  selectedAIProjects: "Selected AI & Machine Learning Projects",
  frontend: "Earlier Web Engineering",
  visitProject: "Visit project",

  featuredProjects: [
    {
      id: "javert",
      type: "Applied AI · E-commerce",
      title: "Javert — Intelligent Commerce & Retail Operations",
      desc:
        "Designed intelligent commerce capabilities for a real menswear business: multi-factor product ranking, smart outfit compatibility, personalized size guidance, visual similarity search, product-set management, and seller-facing inventory and pricing workflows with Telegram operational notifications.",
      tags: ["Recommendation", "Ranking", "Visual Search", "Personalization", "WooCommerce"],
      metrics: [
        "Sales + popularity + stock scoring",
        "Color / season / fit matching",
        "Inventory + order Telegram automation",
      ],
      href: "https://javert.store",
      domain: "javert.store",
      image: "/project-shots/javert.webp",
      imageAlt: "Javert Store homepage",
      visualLabel: "JAVERT",
    },
    {
      id: "petro",
      type: "Applied AI · B2B Product Discovery",
      title: "Petro Nour Mehr — AI Assistant & Intelligent Search",
      desc:
        "Built AI-enabled product-discovery capabilities for a B2B petrochemical business, including a knowledge-based customer assistant and intelligent search across technical product information and commercial website content.",
      tags: ["AI Assistant", "Knowledge Base", "Product Search", "B2B", "Web Engineering"],
      metrics: ["Knowledge-driven assistance", "Intelligent catalog discovery"],
      href: "https://petronourmehr.com",
      domain: "petronourmehr.com",
      image: "/project-shots/petro.webp",
      imageAlt: "Petro Nour Mehr homepage",
      visualLabel: "PNM · AI",
    },
    {
      id: "research",
      type: "Research · Computer Vision",
      title: "SNN + BLS Multi-Object Tracking for Autonomous Driving",
      desc:
        "Graduate research combining Spiking Neural Networks with Broad Learning Systems for multi-object tracking on KITTI, integrating spatiotemporal feature extraction, neural feature enhancement, and classical track association.",
      tags: ["SNN", "BLS", "KITTI", "Multi-Object Tracking", "Autonomous Driving"],
      metrics: ["77.93 HOTA", "<27 ms/frame", "~9.2% spike activity"],
      href: "",
      domain: "M.Sc. Research · KITTI",
      image: "/project-shots/thesis.webp",
      imageAlt: "Multi-object tracking research preview",
      visualLabel: "SNN × BLS",
    },
  ],

  portfoliosmlList: [
    {
      id: "intrusion",
      href: "",
      title: "Network Intrusion Detection",
      desc: "Analysis and implementation of machine-learning approaches for detecting intrusion attacks in network data.",
      image: BigData,
    },
    {
      id: "yolov8",
      href: "",
      title: "YOLOv8 Object Detection",
      desc: "Object-detection system using YOLOv8 with an interactive Streamlit-based application.",
      image: ObjectDetection,
    },
    {
      id: "captioning",
      href: "",
      title: "Image Captioning",
      desc: "CNN and LSTM-based image-caption generation and evaluation using the Flickr8k dataset.",
      image: ImageCaptioning,
    },
    {
      id: "forecasting",
      href: "",
      title: "Electricity Consumption Forecasting",
      desc: "Time-series electricity-demand forecasting using recurrent neural networks and LSTM.",
      image: ElectricityConsumptionForecast,
    },
  ],

  portfoliosList: [
    {
      id: "digikala",
      href: "https://digikala.com",
      title: "Digikala",
      desc: "Frontend engineering experience on a large-scale e-commerce platform and React-based production interfaces.",
      image: digiDesign,
    },
    {
      id: "ficas",
      href: "https://ficas.com",
      title: "Ficas",
      desc: "Frontend and website-management work for a Swiss investment and digital-asset company.",
      image: ficasDesign,
    },
    {
      id: "parsshir",
      href: "https://www.pars-shir.com/",
      title: "Pars Shir",
      desc: "Frontend and backend web-development work for an industrial manufacturer.",
      image: parsDesign,
    },
  ],

  writingPageTitle: "WRITING & READING",
  writingEyebrow: "Technical Interests",
  writingIntroTitle: "Selected technical reading",
  writingLead:
    "This page collects references that are closely related to my research and engineering interests, especially neuromorphic computing, spiking neural networks, intelligent perception, and practical AI systems.",
  writingDisclosure:
    "The articles below are external references and are not presented as my authored publications.",
  writingTopics: ["Spiking Neural Networks", "Neuromorphic Computing", "Computer Vision", "Applied AI"],
  readArticle: "Read at source",

  blogsList: [
    {
      id: "ieee-neuromorphic-big-time",
      href: "https://spectrum.ieee.org/neuromorphic-computing-2671121824",
      title: "Brain-inspired Computing Is Ready for the Big Time",
      desc:
        "IEEE Spectrum discusses the transition of neuromorphic computing from research prototypes toward larger real-world systems and the role of spiking neural networks in that shift.",
      source: "IEEE Spectrum",
      readTime: "6 min read",
      tags: ["Neuromorphic Computing", "SNN", "AI Hardware"],
      image: blogImage6,
    },
    {
      id: "ieee-spinnaker2",
      href: "https://spectrum.ieee.org/neuromorphic-computing-spinnaker2",
      title: "Brain-Inspired Computer Approaches Brain-Like Size",
      desc:
        "A concise look at SpiNNaker2, large-scale neuromorphic computing, event-based processing, and the engineering trade-offs behind flexible brain-inspired systems.",
      source: "IEEE Spectrum",
      readTime: "3 min read",
      tags: ["SpiNNaker2", "Neuromorphic Systems", "Parallel Computing"],
      image: blogImage2,
    },
    {
      id: "ieee-ai-hardware",
      href: "https://spectrum.ieee.org/ai-hardware",
      title: "Toward Optoelectronic Chips That Mimic the Human Brain",
      desc:
        "An IEEE Spectrum interview exploring spiking neuromorphic networks, efficient AI hardware, and the open question of where brain-inspired computing can outperform conventional architectures.",
      source: "IEEE Spectrum",
      readTime: "5 min read",
      tags: ["Spiking Networks", "AI Hardware", "Efficiency"],
      image: blogImage7,
    },
  ],

  contactme: "CONTACT",
  contactEyebrow: "Get in Touch",
  getintouch: "Let's Talk",
  contactLead:
    "If you would like to discuss an AI project, engineering role, research collaboration, or product opportunity, send me a message and I will get back to you.",
  contactInfoTitle: "Contact Information",
  contactInfoLead: "You can also reach me directly through the contact details below.",
  entername: "Your name",
  enteremail: "Your email",
  entersubject: "Subject",
  entermessage: "Tell me a little about what you have in mind",
  sendmessage: "Send Message",
  sending: "Sending...",
  messageSent: "Your message was sent successfully.",
  messageError: "The message could not be sent. Please try again or email me directly.",
  email: "Email",
};

export default en;
